/**
 * @file contains functions used to create urls to reroute via <Link /> or navigate
 * Can be same with the path routes, but we keep urls to be future-proof
 */

import { ChatConversationInterface } from '@gastfreund/roq-ui-react';

import { ROUTE__CHAT } from '../../constants/routing/routes';
import { SEARCH_PARAM__SIDEBAR } from '../../constants/routing/searchParams';
import { SIDEBAR__PARAM_CHAT } from '../../constants/sidebar';
import { Hotel } from '../../generated/graphql';
import { reportError } from '../../services/reporting';

import { getNoMatchUrl } from './404';
import { getHomeUrl } from './home';

/**
 * Get URL for chat route
 *
 * @param hotelId ID of the hotel
 * @returns       A string in a url format
 */
export const getChatUrl = (hotelId: Hotel['id'] | null): string => {
  if (hotelId === null) {
    reportError('HotelId passed to getHomeUrl is null');
    return getNoMatchUrl();
  }
  return `/${hotelId}/${ROUTE__CHAT}`;
};

/**
 * Get URL for chat conversation route
 *
 * @param conversationId ID of the conversation
 * @param hotelId        ID of the hotel
 * @param isTablet       Whether the device is a tablet
 * @returns              A string in a url format
 */
export const getChatConversationUrl = (
  conversationId: ChatConversationInterface['id'] | null,
  hotelId: Hotel['id'] | null,
  isTablet = false,
) => {
  if (hotelId === null) {
    reportError('HotelId passed to getChatConversationUrl was null');
    return getNoMatchUrl();
  }

  if (conversationId === null) {
    reportError('ConversationId passed to getChatConversationUrl was null');
    return getHomeUrl(hotelId);
  }

  const search = isTablet
    ? ''
    : `?${SEARCH_PARAM__SIDEBAR}=${SIDEBAR__PARAM_CHAT}`;

  return `/${hotelId}/${ROUTE__CHAT}/${conversationId}${search}`;
};
